module.exports = __webpack_public_path__ + "img/smartphone.c11eabeb.svg";